import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {
    LoadingOverlayComponent,
    NavigationComponent,
    SigninComponent,
    ToastmessageComponent,
    TranslatableComponent,
    TranslationService,
    TranslationStore
} from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetTranslationRequest } from './use-cases/translation/read-translation-request';
import { GetTranslationUseCase } from './use-cases/translation/read-translation.usecase';

@Component({
    selector: 'pf-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [LoadingOverlayComponent, NavigationComponent, ToastmessageComponent, RouterOutlet]
})
export class AppComponent extends TranslatableComponent {
    adminHomeUrl = '/getorders';
    colorOfNavBar = 'black';
    facebookImgUrl = '';
    facebookURL = '';
    hasAdmin = true;
    hasAdminLogo = false;
    hasLanguageSelector = false;

    hasLogin = false;
    hasLogo = false;
    hasSearchBar = false;
    hasShoppingCart = false;
    headerTitle = 'Multiverzum Admin';

    logoUrl = '../../assets/images/logo.png';

    nameOfTheSite = '';
    positionL = 'PositionL';
    title = 'Multiverzum Admin';

    constructor(
        public _router: Router,
        private _translateService: TranslationService,
        private _readTranslationfileUseCase: GetTranslationUseCase,
        private _http: HttpClient
    ) {
        super(_translateService, _http);
    }
    override readTranslations(http: HttpClient, language: string): Observable<TranslationStore> {
        const request: GetTranslationRequest = { url: './assets/i18n/' + language + '.json' };
        this._readTranslationfileUseCase.execute(request) as unknown as Observable<TranslationStore>;
        return this._http.get<TranslationStore>('./assets/i18n/' + language + '.json');
    }
    override onInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        }
    }

    //Router outlet @Input load
    loadRouterOutletInput(component: SigninComponent) {
        if (component instanceof SigninComponent) {
            component.admin = true;
            component.hasCityAndZipUrl = false;
            component.redirectUrl = '/getorders';
        }
    }
}
